import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  tagList: [],
  productTagList: [],
  orderList: [],
  exportSKU: null,
  searchedProductData: [],
  selectedItemsTags: []
};

const sellerSlice = createSlice({
  name: 'sellerItem',
  initialState,
  reducers: {
    setSellerItem: (state, action) => ({
      ...state,
      list: action.payload
    }),
    setItemTags: (state, action) => ({
      ...state,
      tagList: action.payload
    }),
    setProductTagList: (state, action) => ({
      ...state,
      productTagList: action.payload
    }),
    setSellerOrder: (state, action) => ({
      ...state,
      orderList: action.payload
    }),
    setExportSku: (state, action) => ({
      ...state,
      exportSKU: action.payload
    }),
    setSearchedProductData: (state, action) => ({
      ...state,
      searchedProductData: action.payload
    }),
    setSelectedItemsTags: (state, action) => ({
      ...state,
      selectedItemsTags: action.payload
    })
  }
});

export const {
  setSellerItem,
  setItemTags,
  setSellerOrder,
  setExportSku,
  setProductTagList,
  setSearchedProductData,
  setSelectedItemsTags
} = sellerSlice.actions;

export default sellerSlice.reducer;
